export default {
  title: "Participant Code",
  invitePlaceholder: "Enter a participant code",
  tooltip:
    "Participant code opens up new personal account features. Available after registration of the contract for participation in the exhibition. <br /> Here you can also enter the access code for the booth construction company.",
  successInvite: "You have been granted access to the company {companyName}",
  error: {
    notFound: "Invite was not found",
    userMismatch: "Invite belongs to another user",
    server: "Server error",
    userFromDifferentCompany: "User is associated with another company",
    participantNotFound: "Participant not found",
    participantCreationError: "Participation creation error",
    calendarElementCreationError: "Calendar element creation error",
    colorgNotFound: "Collective organiser participation application not found",
    companyNotFound: "Company not found"
  }
};
